import { Box, styled } from '@material-ui/core';

export const InfoViewContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: 10,
}));
